import { render, staticRenderFns } from "./RatingReports.vue?vue&type=template&id=dbfa0906&scoped=true&"
import script from "./RatingReports.vue?vue&type=script&lang=ts&"
export * from "./RatingReports.vue?vue&type=script&lang=ts&"
import style0 from "./RatingReports.vue?vue&type=style&index=0&id=dbfa0906&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbfa0906",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VCard,VCardText,VDivider,VProgressLinear})
